(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-variant-previews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('om-card-variants')) {
    customElements.define('om-card-variants', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        this.card = this.closest('product-card');
        this.items = Array.from(this.querySelectorAll('.om-variant-preview'));
        this.more = this.querySelector('.om-card-variants__more');
        this.caption = this.querySelector('.om-card-variants__caption');
        this.expanded = false;
        const signal = this.controller.signal;
        this.items.forEach(item => {
          item.setAttribute('role', 'button');
          item.setAttribute('aria-pressed', 'false');
          item.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.select(item);
          }, { signal });
          item.addEventListener('keydown', event => {
            if (event.key === ' ') {
              event.preventDefault();
              this.select(item);
            }
          }, { signal });
        });
        this.more.addEventListener('click', () => {
          this.expanded = !this.expanded;
          this.layout();
        }, { signal });
        this.observer = new ResizeObserver(() => this.layout());
        this.observer.observe(this);
        this.layout();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
      layout() {
        const list = this.querySelector('.om-card-variants__list');
        const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        const itemWidth = this.items[0].getBoundingClientRect().width;
        const slots = Math.max(2, Math.min(5, Math.floor((list.clientWidth + gap) / (itemWidth + gap))));
        const overflow = this.items.length > slots;
        const visible = overflow ? slots - 1 : slots;
        this.items.forEach((item, index) => {
          item.hidden = !this.expanded && index >= visible;
        });
        this.more.hidden = !overflow;
        this.more.textContent = this.expanded ? '−' : `+${Math.max(0, this.items.length - visible)}`;
        this.more.setAttribute('aria-expanded', String(this.expanded));
        this.more.setAttribute('aria-label', this.expanded ? this.dataset.lessLabel : this.dataset.moreLabel);
        this.more.title = this.more.getAttribute('aria-label');
      }
      select(item) {
        const card = this.card;
        const image = card.querySelector('.product-card__image--primary');
        if (image) {
          image.srcset = item.dataset.imageSrcset;
          image.src = item.dataset.imageSrc;
          image.alt = item.dataset.imageAlt;
        }
        card.setAttribute('data-variant-preview-selected', '');
        card.querySelectorAll('.product-card__media, a.product-title').forEach(link => {
          link.href = item.href;
        });
        const quickBuy = card.querySelector('quick-buy-modal');
        if (quickBuy) {
          quickBuy.setAttribute('handle', `${card.getAttribute('handle')}?variant=${item.dataset.variantId}`);
        }
        const price = card.querySelector('.product-card__info price-list');
        const nextPrice = item.querySelector('[data-preview-price]').content.firstElementChild;
        if (price && nextPrice) price.replaceWith(nextPrice.cloneNode(true));
        card.querySelectorAll('.product-card__figure on-sale-badge').forEach(badge => badge.remove());
        const nextDiscount = item.querySelector('[data-preview-discount]').content.firstElementChild;
        if (nextDiscount && card.hasAttribute('data-preview-badges')) {
          const figure = card.querySelector('.product-card__figure');
          let badges = figure.querySelector('badge-list');
          if (!badges) {
            badges = document.createElement('badge-list');
            badges.className = 'badge-list badge-list--vertical';
            figure.prepend(badges);
          }
          badges.append(nextDiscount.cloneNode(true));
        }
        this.items.forEach(option => option.setAttribute('aria-pressed', String(option === item)));
        this.caption.textContent = item.dataset.variantTitle;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
